<nav
	class="top-nav"
	[ngClass]="{ 'with-shadow': showTopNavShadow }"
	id="jep-topbar"
>
	<div class="top-nav__logo-box" [ngClass]="{ 'logo-collapse': isCollapse }">
		<a [routerLink]="['clients']">
			<img
				class="top-nav__img"
				[src]="
					isCollapse
						? 'assets/images/jepto-logo-icon.svg'
						: 'assets/images/jepto%20-%20white.svg'
				"
				alt="Jepto"
			/>
		</a>
	</div>
	<div class="top-nav__left-box">
		<div class="top-nav__accounts-box">
			<div class="top-nav__accounts" *ngIf="isShowTopbarAccountName">
				<jep-avatar
					class="top-nav__accounts__avatar"
					[name]="accountDetails?.name"
					[src]="accountDetails?.logo"
					theme="primary"
				>
				</jep-avatar>
				<span class="top-nav__selected-text">{{
					accountDetails?.name
				}}</span>
			</div>
			<!-- && accountType !== 'Business' && accountType !== 'Data Warehouse' && !showDropdownPipeline && accountType !== 'Reporting' && accountType !== 'Basic' -->
			<div
				class="top-nav__accounts"
				*ngIf="!isShowTopbarAccountName && showDropdownClient === true"
			>
				<global-clients-dropdown></global-clients-dropdown>
			</div>
			<div class="top-nav__accounts" *ngIf="showDropdownPipeline">
				<global-pipelines-dropdown></global-pipelines-dropdown>
			</div>
		</div>
		<!-- <div class="top-nav">
            <div class="top-nav__indicator">

            </div>
        </div> -->
		<div
			class="top-nav__profile-box"
			[class.has-billing-banner]="hasBillingBanner"
		>
			<div
				class="indicator"
				*ngIf="isTopbarNotificationVisible('jeptoTrial')"
			>
				<div class="img">
					<i class="icon-clock" aria-hidden="true"></i>
				</div>
				<div class="label">
					<span class="trial-msg"
						><strong
							>Jepto trial ends {{ durationPlan }}</strong
						></span
					>
					<span class="plan"
						>You are trialing the
						{{
							
								accountDetails?.subscription?.planName
							 | jepBasicPlanNamePipe
						}}
						plan.
						<span (click)="subscribeNow()" class="route"
							>Subscribe Now
							<i class="icon-chevron-right"></i></span
					></span>
				</div>
			</div>
			<div
				class="indicator"
				*ngIf="isTopbarNotificationVisible('dwTrial')"
			>
				<div class="img">
					<i class="icon-clock" aria-hidden="true"></i>
				</div>
				<div class="label">
					<span class="trial-msg"
						><strong
							>Data Warehouse trial ends in {{ durationDW }}
							{{ durationDW > 0 ? 'days' : 'day' }}</strong
						></span
					>
					<span class="plan"
						>You have
						{{ subscriptionDetails?.details?.credit?.value }}
						Credits to try.
						<span (click)="addCreditsNow()" class="route"
							>Add Credits Now
							<i class="icon-chevron-right"></i></span
					></span>
				</div>
			</div>
			<div
				class="indicator non"
				*ngIf="isTopbarNotificationVisible('subscriptionEnding')"
			>
				<div class="img">
					<i class="icon-clock"></i>
				</div>
				<div class="label">
					<span class="trial-msg"
						><strong
							>Subscription ends {{ durationPlan }}</strong
						></span
					>
					<span class="plan"
						>To keep your plan active please subscribe again.
						<span (click)="subscribeNow()" class="route"
							>Subscribe Now
							<i class="icon-chevron-right"></i></span
					></span>
				</div>
			</div>
			<div
				class="indicator exp"
				*ngIf="isTopbarNotificationVisible('cardExpired')"
			>
				<div class="img">
					<i class="icon-credit-card"></i>
				</div>
				<div class="label">
					<span class="trial-msg"
						><strong>Your Credit Card has expired</strong></span
					>
					<span class="plan"
						>Update to avoid disruptions.
						<span (click)="subscribeNow()" class="route"
							>Update Payment Method
							<i class="icon-chevron-right"></i></span
					></span>
				</div>
			</div>
			<div
				class="indicator expng"
				*ngIf="isTopbarNotificationVisible('cardExpiring')"
			>
				<div class="img">
					<i class="icon-credit-card"></i>
				</div>
				<div class="label">
					<span class="trial-msg"
						><strong
							>Your Credit Card is expiring soon</strong
						></span
					>
					<span class="plan"
						>Update your card details.
						<span (click)="subscribeNow()" class="route"
							>Update Payment Method
							<i class="icon-chevron-right"></i></span
					></span>
				</div>
			</div>
			<div
				class="indicator fl"
				*ngIf="isTopbarNotificationVisible('paymentFailed')"
			>
				<div class="img">
					<i class="icon-credit-card"></i>
				</div>
				<div class="label">
					<span class="trial-msg"
						><strong
							>Subscription payment attempt failed</strong
						></span
					>
					<span class="plan"
						>Check your card details.
						<span (click)="subscribeNow()" class="route"
							>Update Payment Method
							<i class="icon-chevron-right"></i></span
					></span>
				</div>
			</div>
			<div class="jepto-feedback-container"></div>
			@if (isTopbarNotificationVisible('incentive')) {
				<jepto-ai-credits-incentives-panel
					variant="topbar"
					testId="topbar-ai-credits-incentives"
				/>
			}
			<a
				class="frill-widget-container nav-link dropdown-toggle nav-user"
				data-bs-toggle="dropdown"
				href="javascript:void(0);"
				role="button"
				aria-haspopup="false"
				aria-expanded="false"
			>
				<span class="bell-badge-container">
					<i class="icon-bell" data-test="jepto-feedback-bell"></i>
					<span
						*ngIf="unreadAnnouncementsCount > 0"
						class="bell-badge"
					>
						{{ unreadAnnouncementsCount }}
					</span>
				</span>
			</a>
			<jep-profile-dropdown
				[menus]="profileMenus"
				[avatar]="getUserCurrentLogin?.logo"
				[firstName]="
					getUserCurrentLogin?.firstName
				"
				[lastName]="
					getUserCurrentLogin?.lastName
				"
				[email]="getUserCurrentLogin?.email"
				[plan]="plan"
				class="hide-for-medium-down top-nav__profile-dd"
				(onSelectMenu)="handleSelectedMenu($event)"
			>
			</jep-profile-dropdown>
			<div class="top-nav__sidemenu">
				<span class="icon-menu"></span>
			</div>
		</div>
	</div>
</nav>
